/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import goToGoogleMaps from "utils/goToGoogleMaps";
import { CSVLink } from "react-csv";

export default function MunsAccordion(props) {
  const {
    item,
    polesList,
    toggleUnselectMunDialog,
    selectionGeometry,
    zoneName,
  } = props;

  const [filteredUnits, setFilteredUnits] = useState([]);
  const [wattageCounters, setWattageCounters] = useState(null);
  const [poleTypeCounters, setPoleTypeCounters] = useState(null);

  useEffect(() => {
    const tempFilteredUnits = polesList?.filter(
      (pole) => pole.Municipality === item
    );

    const tempWattageCounters = tempFilteredUnits.reduce(
      (counter, wattageItem) => {
        if (wattageItem.Category === "30 Watt")
          return { ...counter, wat30: counter.wat30 + 1 };
        if (wattageItem.Category === "40 Watt")
          return { ...counter, wat40: counter.wat40 + 1 };
        if (wattageItem.Category === "70 Watt")
          return { ...counter, wat70: counter.wat70 + 1 };
        return counter;
      },
      {
        wat30: 0,
        wat40: 0,
        wat70: 0,
      }
    );

    const tempPoleTypeCounters = tempFilteredUnits.reduce(
      (counter, pole) => {
        if (pole.Pole_TypeName === "Empty Pole")
          return { ...counter, empty: counter.empty + 1 };
        if (pole.Pole_TypeName === "Ordinary")
          return { ...counter, ordinary: counter.ordinary + 1 };
        if (pole.Pole_TypeName === "LED")
          return { ...counter, led: counter.led + 1 };
        if (pole.Pole_TypeName === "Mixed")
          return { ...counter, mixed: counter.mixed + 1 };
        return counter;
      },
      {
        empty: 0,
        ordinary: 0,
        led: 0,
        mixed: 0,
      }
    );

    setWattageCounters(tempWattageCounters);
    setPoleTypeCounters(tempPoleTypeCounters);
    setFilteredUnits(tempFilteredUnits);
  }, [polesList, item]);

  console.log(polesList);

  const exportHeaders = useMemo(
    () => [
      {
        key: "GlobalID",
        label: "Pole ID",
      },
      {
        key: "Point_ID",
        label: "Point ID",
      },
      {
        key: "Pole_TypeName",
        label: "Pole Type",
      },
      {
        key: "Category",
        label: "Category",
      },
      {
        key: "Governorate",
        label: "Governorate",
      },
      {
        key: "Municipality",
        label: "Municipality",
      },
      {
        key: "Localities_A",
        label: "Area",
      },
      {
        key: "StatusName",
        label: "Status",
      },
      {
        key: "Fail_Reason",
        label: "Fail Reason",
      },
      {
        key: "Easting",
        label: "X",
      },
      {
        key: "Northing",
        label: "Y",
      },
      {
        key: "Installation_Date_ISO",
        label: "Installation Date",
      },
    ],
    []
  );

  return (
    <div key={item.OBJECTID} className="auction_accordion">
      <div className="accordion-item">
        <div className="accordion-header">
          <div className="heading_container">
            <span className="heading_title">Municipality</span>
          </div>
          {selectionGeometry ? (
            <button
              type="button"
              className="btn btn--primary location_btn"
              onClick={() => goToGoogleMaps(selectionGeometry)}
            >
              <i className="fa-solid fa-map-location-dot" />
            </button>
          ) : null}
          {toggleUnselectMunDialog ? (
            <button
              type="button"
              className="btn btn--primary add_section_btn"
              onClick={() => toggleUnselectMunDialog(item)}
            >
              <i className="fa-solid fa-x" />
              <span>Unselect</span>
            </button>
          ) : null}
          {polesList?.length && zoneName ? (
            <CSVLink
              data={polesList}
              target="_blank"
              filename={`${zoneName}.csv`}
              className="btn btn--primary export_btn"
              headers={exportHeaders}
            >
              <i className="fa-solid fa-file-export clickable" key="export" />
            </CSVLink>
          ) : null}
          <div className="heading_text_container">
            <span className="heading_text">{item}</span>
          </div>
          <hr style={{ marginTop: "0" }} />
          <div className="date_text_container">
            <span className="date_text">
              <b>30 Watt:</b> {wattageCounters?.wat30}
            </span>
            <span className="date_text">
              <b>40 Watt:</b> {wattageCounters?.wat40}
            </span>
            <span className="date_text">
              <b>70 Watt:</b> {wattageCounters?.wat70}
            </span>
            <span className="date_text" style={{ color: "red" }}>
              <b>Total:</b> {filteredUnits?.length}
            </span>
          </div>
          <hr style={{ marginTop: "10px", marginBottom: "10px" }} />
          <div className="date_text_container">
            <span className="date_text">
              <b>Empty:</b> {poleTypeCounters?.empty}
            </span>
            <span className="date_text">
              <b>Ordinary:</b> {poleTypeCounters?.ordinary}
            </span>
            <span className="date_text">
              <b>LED:</b> {poleTypeCounters?.led}
            </span>
            <span className="date_text">
              <b>Mixed:</b> {poleTypeCounters?.mixed}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

MunsAccordion.propTypes = {
  item: PropTypes.object.isRequired,
  selectionGeometry: PropTypes.object.isRequired,
  polesList: PropTypes.array.isRequired,
  toggleUnselectMunDialog: PropTypes.func.isRequired,
  zoneName: PropTypes.string.isRequired,
};
